import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { DeclarationRevendication } from 'src/app/data/declaration/models/declaration-revendication.model';
import { DREVSaisie } from 'src/app/data/declaration/models/drevsaisie.model';
import { UntypedFormBuilder, UntypedFormGroup, Validators, UntypedFormControl, UntypedFormArray, Form, AbstractControl } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { merge, Subject, zip } from 'rxjs';
import { ReferentielService } from 'src/app/data/declaration/services/referentiel/referentiel.service';
import { RefMvtDistillationVCI } from 'src/app/data/declaration/models/ref-mvt-distillation-vci.model';
import { RefTypeFichier } from 'src/app/data/edition/models/ref-type-fichier.model';
import { ModalService } from 'src/app/shared/services/modal/modal.service';
import { GedFacade } from 'src/app/data/edition/facades/ged.facade';
import { TranslateService } from '@ngx-translate/core';
import { MvtDistillationVci } from 'src/app/data/declaration/models/mvt-distillation-vci.model';
import * as moment from 'moment';
import { GedFichier } from 'src/app/data/edition/models/ged-fichier.model';
import { NavigationContext, SessionContext } from 'src/app/core/services/config/app.settings';
import { ToastrService } from 'ngx-toastr';
import { DeclarationsService } from 'src/app/data/declaration/services/declarations/declarations.service';

@Component({
    selector: 'app-saisie-vci',
    templateUrl: './saisie-vci.component.html',
    styleUrls: ['./saisie-vci.component.scss'],
    standalone: false
})
export class SaisieVciComponent implements OnInit {
    @Input() campagne: number;

    @Input() drev: DeclarationRevendication;

    @Input() saisie: DREVSaisie;

    @Input() creation = true;

    drevsN1: DeclarationRevendication[];
    @ViewChild('stockVCIModal', { static: true }) stockVCIModal: any;

    formGroup: UntypedFormGroup;

    private file: File;
    public uploadEnCours = false;

    get idIntervenant(): number {
        if (NavigationContext.has('idOperateur')) {
            return NavigationContext.get('idOperateur');
        } else {
            return SessionContext.get('idIntervenant');
        }
    }

    public refMvtDistillations: RefMvtDistillationVCI[] = [];

    loaded = false;
    twoDigits = /(^\d+$)|(^\d+\.\d{1,2}$)|(^\d+,\d{1,2}$)/;

  COLORS = [
    '#875EBF',
    '#47444b',
    '#F68235'
  ];

    getTankValue(tank: 'vciNouveau' | 'stockVci') {
        const vciNouveau = this.saisie.vciNouveau;
        const stockVci = this.getFieldValue('stock');
        const max = Math.max(vciNouveau, stockVci);

        const v = tank === 'vciNouveau' ? vciNouveau : stockVci;

        console.log(this.saisie);
        return Math.round((v / max) * 30);
    }

    get somme() {
        return this.formGroup
            ? this.getFieldValue('remplacement') + this.getFieldValue('substitution') + this.getFieldValue('complement') + this.getFieldValue('detruit')
            : 0;
    }

    getDistillations() {
        return (this.formGroup.get('distillations') as UntypedFormArray).controls;
    }

    constructor(
        private readonly fb: UntypedFormBuilder,
        private readonly referentielService: ReferentielService,
        private readonly declarationsService: DeclarationsService,
        private gedFacade: GedFacade,
        private modalService: ModalService,
        private toastrService: ToastrService,
        private translateService: TranslateService,
        private readonly modalNgService: NgbModal,
        private readonly modal: NgbActiveModal
    ) {}

    ngOnInit() {
        this.referentielService.getReferentiel().subscribe(ref => {
            this.refMvtDistillations = ref.refMvtDistillationVCI;
        });

        this.gedFacade.loadRefTypesFichier();
        this.gedFacade.setIdIntervenant(this.idIntervenant);

        this.formGroup = this.fb.group({
            stock: [
                this.saisie.stockVci || this.drev.vciPasse,
                [Validators.required, Validators.pattern(this.twoDigits), this.positifValidator, this.totalValidator.bind(this)]
            ],
            remplacement: [this.saisie.vciRemplacement, [Validators.required, Validators.pattern(this.twoDigits), this.positifValidator]],
            substitution: [this.saisie.vciSubstitution, [Validators.required, Validators.pattern(this.twoDigits), this.positifValidator]],
            complement: [this.saisie.vciComplement, [Validators.required, Validators.pattern(this.twoDigits), this.positifValidator]],
            detruit: [this.saisie.vciDetruit, [Validators.required, Validators.pattern(this.twoDigits), this.positifValidator]],
            distillations: this.fb.array([])
        });

        const distillations = this.formGroup.get('distillations') as UntypedFormArray;
        this.saisie.distillations.forEach(distillation => {
            let form: UntypedFormGroup = null;

            form = this.fb.group({
                type: [this.refMvtDistillations.find(dist => dist.id === distillation.refMvtDistillationVCI.id), [Validators.required]],
                dateDistillation: [
                    {
                        year: distillation.dateDistillation.year(),
                        month: distillation.dateDistillation.month() + 1,
                        day: distillation.dateDistillation.date()
                    },
                    [Validators.required]
                ],
                volume: [distillation.volume, [Validators.pattern(/(^\d+$)|(^\d+\.\d{1,2}$)|(^\d+,\d{1,2}$)/), Validators.required]],
                fichier: undefined
                // fichierUuid: distillation.uuid
            });

            distillations.push(form);

            this.sommeVol();
        });

        merge(
            this.getField('remplacement').valueChanges,
            this.getField('substitution').valueChanges,
            this.getField('complement').valueChanges,
            this.getField('detruit').valueChanges
        ).subscribe(() => {
            this.getField('stock').updateValueAndValidity();
        });

        this.loaded = true;
    }

    getField(key: string) {
        return this.formGroup.get(key);
    }

    getFieldValue(key: string) {
        return (this.getField(key).value as number) || 0;
    }

    positifValidator(control: UntypedFormControl) {
        if (!isNaN(control.value)) {
            if (control.value < 0) {
                return { invalid: true };
            }
        }

        return null;
    }

    totalValidator(control: UntypedFormControl) {
        const value = control.value;
        if (!isNaN(value) && !isNaN(this.somme)) {
            const PRECISION_DECIMAL = 2;

      if (this.somme && this.somme.toFixed(PRECISION_DECIMAL) != (value as number).toFixed(PRECISION_DECIMAL)) {
        return { invalid: true, somme_incorrecte: true };
      }
    } else {
      return { invalid: true };
    }

        return null;
    }

    submit() {
        if (this.formGroup.valid) {
            if (this.creation) {
                this.sommeVol();
                this.saisie.vciComplement = this.getFieldValue('complement');
                this.saisie.vciRemplacement = this.getFieldValue('remplacement');
                this.saisie.vciSubstitution = this.getFieldValue('substitution');
                this.saisie.vciDetruit = this.getFieldValue('detruit');
                this.saisie.stockVci = this.getFieldValue('stock');
                this.saisie.vciNouveau = this.drev.vciEnCours;

                const distillations: MvtDistillationVci[] = [];

                (this.formGroup.get('distillations') as UntypedFormArray).controls.forEach(ctrl => {
                    const distillation = new MvtDistillationVci();
                  
                    distillation.volume = ctrl.get('volume').value;
                  
                    distillation.dateDistillation = moment([
                      ctrl.get('dateDistillation').value.year,
                      ctrl.get('dateDistillation').value.month - 1,
                      ctrl.get('dateDistillation').value.day
                    ]);
                  
                    distillation.refMvtDistillationVCI = ctrl.get('type').value;
                    // distillation.uuid = ctrl.get('fichierUuid').value;
                  
                    distillations.push(distillation);
                  });

                this.saisie.distillations = distillations;

                this.modal.close(this.saisie);
            } else {
                this.modal.close(this.saisie);
            }
        }
    }

    dismiss() {
        this.modal.dismiss();
    }

    getDrevTankData() {
        const v1 = this.drev.vinsEnCours - this.getFieldValue('remplacement') - this.getFieldValue('substitution');
        const v2 = this.getFieldValue('substitution') + this.getFieldValue('complement');
        const v3 = this.getFieldValue('remplacement');
        const total = v1 + v2 + v3;
        let tankv1 = (v1 / total) * 100;
        let tankv2 = (v2 / total) * 100;
        let tankv3 = (v3 / total) * 100;

        if (tankv2 < 10 && tankv2 > 0 && tankv3 < 10 && tankv3 > 0) {
            tankv1 = 80;
            tankv2 = 10;
            tankv3 = 10;
        } else if (tankv2 < 5 && tankv2 > 0) {
            tankv1 = 95;
            tankv2 = 5;
        } else if (tankv3 < 5 && tankv3 > 0) {
            tankv1 = 95;
            tankv3 = 5;
        }

        return [
            { value: tankv1, color: this.COLORS[0], libelle: Math.round(v1 * 100) / 100 + ' hL' },
            { value: tankv2, color: this.COLORS[1], libelle: Math.round(v2 * 100) / 100 + ' hL' },
            { value: tankv3, color: this.COLORS[2], libelle: Math.round(v3 * 100) / 100 + ' hL (' + (this.campagne - 1) + ')' }
        ];
    }

    getVciTankData() {
        const drevValue =
            this.drev.drevSaisie.vciNouveau -
            this.getFieldValue('remplacement') -
            this.getFieldValue('substitution') +
            this.getFieldValue('substitution') +
            this.getFieldValue('complement');

        const v1 = this.getFieldValue('remplacement');
        const v2 = this.drev.drevSaisie.vciNouveau;

        const total = v1 + v2;
        let max = drevValue;
        if (total < drevValue / 4) {
            max = 4 * total;
        }
        if (total > drevValue) {
            max = total;
        }

        const tankv1 = v1 > 0 ? Math.max((v1 / max) * 100, 5) : 0;
        const tankv2 = v2 > 0 ? Math.max((v2 / max) * 100, 5) : 0;

        return [
            { value: tankv2, color: this.COLORS[1], libelle: Math.round(v2 * 100) / 100 + ' hL' },
            { value: tankv1, color: this.COLORS[0], libelle: Math.round(v1 * 100) / 100 + ' hL' }
        ];
    }

    public sommeVol() {
        const totalVolume = (this.formGroup.get('distillations') as UntypedFormArray).controls
            .map(ctrl => (ctrl.get('volume') ? ctrl.get('volume').value : 0)) // extraire la valeur volume
            .reduce((acc, vol) => acc + Number(vol), 0); // sommer

        this.getField('detruit').setValue(totalVolume);
    }

    add(type: string) {
        let form: UntypedFormGroup = null;

        form = this.fb.group({
            type: [undefined, [Validators.required]],
            dateDistillation: [undefined, [Validators.required]],
            volume: [undefined, [Validators.pattern(/(^\d+$)|(^\d+\.\d{1,2}$)|(^\d+,\d{1,2}$)/), Validators.required]],
            fichier: [null],
            fichierUuid: [null]
        });

        const control = this.formGroup.get('distillations') as UntypedFormArray;
        control.push(form);
    }

    remove(index: number) {
        const control = this.formGroup.get('distillations') as UntypedFormArray;
        control.removeAt(index);

        this.sommeVol();
    }

    public onFileChange(event: any, distillation: AbstractControl): void {
        if (event.target.files && event.target.files.length > 0) {
            this.file = event.target.files[0];
            this.uploadEnCours = true;
            const fileExtension = this.file.name.split('.').pop();

            const filename = `distillation-${this.idIntervenant}-${moment().format('YYYY-MM-DDTHHmmss')}.${fileExtension}`;
            zip(this.gedFacade.postUploadFile(this.file), this.gedFacade.refTypesFichier$).subscribe(
                ([uuid, typesFichiers]: [string, Array<RefTypeFichier>]) => {
                    this.gedFacade
                        .postFile(
                            Object.assign(new GedFichier(), {
                                uuid: uuid,
                                libelle: filename,
                                typeFichier: typesFichiers.find((typeFichier: RefTypeFichier) => typeFichier.code === 'DOCUMENT'),
                                estPublic: false,
                                estArchive: false,
                                intervenants: [this.idIntervenant]
                            })
                        )
                        .subscribe();

                    const control = distillation.get('fichierUuid');
                    if (control) {
                        control.setValue(uuid);
                    }
                    this.uploadEnCours = false;

                    this.toastrService.success(
                        this.translateService.instant('page.documents.documents-enregistre') + ' ' + this.file.name.split('.').slice(0, -1).join('.')
                    );
                }
            );
        }
    }

    public stockVci() {
        this.declarationsService.getConsultationDREV(this.idIntervenant, (this.campagne - 1).toString()).subscribe(drev => {
            if (drev.aocs) {
                this.drevsN1 = drev.aocs.filter(aoc => {
                    return aoc.codeProduit.trim() === this.drev.codeProduit.trim();
                });
            }

            this.modalNgService.open(this.stockVCIModal, { centered: true });
        });
    }

    getTotalVCI(): number {
        return this.drevsN1.reduce((sum, stock) => sum + stock.vciEnCours, 0);
    }

    public onDownloadFile(uuid: string): void {
        this.gedFacade.downloadFile(uuid);
    }
}
